import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/ant-design-vue.js'
import 'ant-design-vue/dist/antd.less'
import vueEsign from 'vue-esign'

import VueI18n from 'vue-i18n'
import ja_JP from './common/lang/ja-jp'
import zh_CN from './common/lang/zh-cn'

Vue.config.productionTip = false
Vue.use(VueI18n)

//less
import less from 'less'
Vue.use(less)
Vue.use(vueEsign)
// 在 main.js 中全局注册
import wanakanaMixin from '@/mixins/wanakanaMixin';

Vue.mixin(wanakanaMixin);

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'ja_JP',
  messages: {
    'zh_CN': zh_CN,
    'ja_JP': ja_JP
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
